import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Report = Loadable(lazy(() => import('./Report')));
const DutyStatus = Loadable(lazy(() => import('./DutyStatus')));
const DriverPerformanceReport = Loadable(
	lazy(() => import('./DriverPerformanceReport'))
);
const EditedReport = Loadable(lazy(() => import('./EditedReport')));
const RejectedEdit = Loadable(lazy(() => import('./RejectedEdit')));
const DrivingReport = Loadable(lazy(() => import('./DrivingReport')));
const OdometerJumpReport = Loadable(lazy(() => import('./OdometerJumpReport')));
const MalfunctionReport = Loadable(lazy(() => import('./MalfunctionReport')));
const UnassignedReport = Loadable(lazy(() => import('./UnassignedReport')));
const VoilationReport = Loadable(lazy(() => import('./VoilationReport')));
const HosDetail = Loadable(lazy(() => import('./HosDetail')));
const PayrollReport = Loadable(lazy(() => import('./PayrollReport')));
const TrackerReport = Loadable(lazy(() => import('./TrackerReport')));
const DTCReport = Loadable(lazy(() => import('./DTCReport')));
const EldDisconnectReport = Loadable(
	lazy(() => import('./EldDisconnectReport'))
);

const ReportRoutes = [
	{
		path: '/report',
		element: <Report />,
		auth: authRoles.admin,
	},
	{
		path: '/dutystatus',
		element: <DutyStatus />,
		auth: authRoles.admin,
	},
	{
		path: '/driverperformance',
		element: <DriverPerformanceReport />,
		auth: authRoles.admin,
	},
	{
		path: '/editedatareport',
		element: <EditedReport />,
		auth: authRoles.admin,
	},
	{
		path: '/rejectededit',
		element: <RejectedEdit />,
		auth: authRoles.admin,
	},
	{
		path: '/drivingeventreport',
		element: <DrivingReport />,
		auth: authRoles.admin,
	},
	{
		path: '/elddisconnectreport',
		element: <EldDisconnectReport />,
		auth: authRoles.admin,
	},
	{
		path: '/odometerjumpreport',
		element: <OdometerJumpReport />,
		auth: authRoles.admin,
	},
	{
		path: '/malfunctionreport',
		element: <MalfunctionReport />,
		auth: authRoles.admin,
	},
	{
		path: '/unassignedreport',
		element: <UnassignedReport />,
		auth: authRoles.admin,
	},
	{
		path: '/voilationreport',
		element: <VoilationReport />,
		auth: authRoles.admin,
	},
	{
		path: '/hosvoilationdetail',
		element: <HosDetail />,
		auth: authRoles.admin,
	},
	{
		path: '/payrollreport',
		element: <PayrollReport />,
		auth: authRoles.admin,
	},
	{
		path: '/trackerreport',
		element: <TrackerReport />,
		auth: authRoles.admin,
	},
	{
		path: '/dtcreport',
		element: <DTCReport />,
		auth: authRoles.admin,
	},
];

export default ReportRoutes;
